import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export const ContainerWaveChildrenComponent = ({ children }) => {
    return (_jsx(_Fragment, { children: !children ? _jsx(_Fragment, {}) : children }));
};
//# sourceMappingURL=container-wave-children.component.js.map